


















































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import { FetchState } from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import * as RouteNames from "@/employee/route-names";
import { useNotifierStore } from "@/shared/store/notifier";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { Location } from "vue-router";
import * as SharedRoutes from "@/shared/route-names";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class PreenrollmentManagement extends Vue {
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;
  isSubmitting = false;

  notifierStore = useNotifierStore();

  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();

  drivewealthStore = useDrivewealthStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthSweepStore = useDrivewealthSweepStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();
  signingDocumentStore = useSigningDocumentStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Watch("$props", { deep: true })
  load () {
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({});
    this.drivewealthWizardStore.loadExistingPreenrollment({ username: this.username, partnerId: this.partnerId });
    this.drivewealthSweepStore.getSweep({ username: this.username, partnerId: this.partnerId });
    this.loadSignedDocumentKey();
  }

  @Watch("investmentDailyBalanceStore.hasEnoughToOpenAccount")
  autoEnroll () {
    if (this.investmentDailyBalanceStore.hasEnoughToOpenAccount && !this.drivewealthStore.isEnrollingNow) {
      this.drivewealthStore.enrollNow()
          .then(() => {
            if (this.drivewealthStore.enrolledAccountId !== null) {
              this.notifierStore.setSuccess("Your investment account has been created");
              this.$router.push(this.redirectLocation(this.drivewealthStore.enrolledAccountId));
              this.$router.go(0);
            } else {
              this.notifierStore.setDanger("Please update enrollment settings");
            }
          })
          .catch(_ => {
            // will fail transparently
          });
    }
  }

  mounted () {
    this.load();
    this.autoEnroll();
  }

  get isLoaded () {
    return this.drivewealthWizardStore.isEnrollmentLoaded
        && this.drivewealthSweepStore.sweepLoaded
        && this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded;
  }

  get accountTypeTitle (): string {
    return "You have Enrolled for the " + this.accountType;
  }

  get accountType (): string {
    return this.drivewealthStore.getAccountManagementTypeTitle(this.drivewealthWizardStore.enrollmentAccountType);
  }

  get accountTypeWithDescriptionCopy (): string {
    const enrollmentType = this.drivewealthWizardStore.enrollmentAccountType;
    const accountType = this.drivewealthStore.getAccountManagementTypeTitle(enrollmentType);
    const descriptionCopy = this.custodianSettingsStore.isHsaBankCustodian ?
      ` ${this.drivewealthStore.getAccountManagementTypeDescriptionCopy(enrollmentType)}` :
      "";

      return `${accountType}${descriptionCopy}`;

  }

  @Watch("this.drivewealthWizardStore.enrollmentAccountType")
  loadSignedDocumentKey () {
    this.signingDocumentStore.getSignedDocumentKey(this.drivewealthWizardStore.enrollmentAccountType);
  }

  onDeleteEnrollment () {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.drivewealthWizardStore.deleteExistingPreenrollment()
          .then(() => {
            this.notifierStore.setSuccess("Investment Enrollment has been cancelled");
            this.riskToleranceQuestionnaireStore.clearStoredResults();
            this.riskToleranceQuestionnaireStore.setFetchState(FetchState.Uninitialized);
          })
          .finally(() => this.isSubmitting = false);
    }
  }

  redirectLocation (accountId: number): Location {
    if (accountId) {
      return {
        name: SharedRoutes.DrivewealthInvestmentAccountV2,
        params: { accountId: `${accountId}`}
      };
    }
    return {name: RouteNames.InvestmentAccountInfo};
  }
}
